@if (spinnerService.loading()) {
  <div class="loader-container">
    <tui-loader
      size="xxl"
      [loading]="true">
    </tui-loader>

    <div class="loader-text">Loading...</div>
  </div>
}